import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next'
import { useMenuContext } from "../../context/menuContext/MenuContext"


import Tab from "./tab/Tab";

import { iconsImage } from "./IconMenu"

export default function Menu() {
  const { t } = useTranslation()

  const [ IdName, SetIdName] = useState("MenuDash");
  const { MenuPageIndex } = useMenuContext();

  useEffect(() => {
    if(MenuPageIndex === 0){
      SetIdName("MenuDash")
    }else{
      SetIdName("MenuList")
    }
  },[MenuPageIndex])

  return (
    <div id={IdName}>
    
      <Tab index={0} path="/"         title={t("home")}     icon={iconsImage.homeIcon} />
      <Tab index={1} path="/projects" title={t("projects")} icon={iconsImage.projectIcon} />
      {/*<Tab index={2} path="/games"    title={t("games")}    icon={iconsImage.gameIcon} />*/}
      <Tab index={3} path="/about"    title={t("about")}    icon={iconsImage.aboutIcon} />

    </div>
  );
}

